const payment_historyRouter = [
    {
        path: "list-payment_history",
        name: "list",
        component: () => import("@/views/admin/need_to_pay"),
        default: true,
        meta: {
            model: "payment_history",
            // requiresAuth: true,
        },
    },
    {
        path: "list-payment_history/add",
        name: "add",
        component: () => import("@/views/admin/need_to_pay/function"),
        default: true,
        meta: {
            model: "payment_history",
            // requiresAuth: true,
        },
    },
    {
        path: "list-payment_history/edit/:id",
        name: "edit",
        component: () => import("@/views/admin/need_to_pay/function"),
        default: true,
        meta: {
            model: "payment_history",
            // requiresAuth: true,
        },
    },
];
export default payment_historyRouter;